import * as React from 'react';

import type {OutcomeType} from 'nutshell-graphql-types';
import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {TaskTemplateCard} from '../cards/task-template-card';

import {CardsContainer} from './cards-container';

type Props = {
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
    outcomeType: OutcomeType;
};

const defaultAutomations = {taskTemplates: []} as const;

export function ClosedLeadTaskTemplateContainer(props: Props) {
    const automations =
        props.closedLeadAutomations.find(
            (automation) => automation.outcomeType === props.outcomeType
        ) || defaultAutomations;

    const taskTemplateCards = automations.taskTemplates.map((taskTemplate, index) => {
        return (
            <TaskTemplateCard
                key={taskTemplate.id}
                index={index}
                parentId={props.outcomeType}
                taskTemplate={taskTemplate}
            />
        );
    });

    return (
        <CardsContainer
            type='closedLeadTaskTemplates'
            isCardBeingDragged={false} // Can't drag closed lead tasks right now
            isLoading={props.isLoading}
            errorMessage={props.errorMessage}
            hideAddCard={false}
            parentId={props.outcomeType}
        >
            {taskTemplateCards}
        </CardsContainer>
    );
}
